import { useWSModalCustom } from "@wingspanhq/fe-component-library";
import { ModalRemoveWorkLogNotes } from ".";

export const useModalRemoveWorkLogNotes = () =>
  useWSModalCustom(ModalRemoveWorkLogNotes);
